var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { transient, autoinject, Container } from 'aurelia-dependency-injection';
import { BrandingBase } from '../../../../../views/app/admin/branding/branding-base';
import { Router } from 'aurelia-router';
import { TokenClient } from '../../../../../services/authentication/token-client.service';
import { I18N } from 'aurelia-i18n';
import { ClientLotteryClientService } from '../../../../../services/modules/client/client-lottery-client-service';
import { NotificationClientService } from '../../../../../services/basics/notification-client.service';
import { DialogClientService } from '../../../../../services/basics/dialog-client.service';
import { BaseResults } from '../../base-results';
import { LookupClientService } from '../../../../../services/lookups/lookup-client.service';
import { ClientHotLotteriesClientService } from '../../../../../services/modules/client/client-hot-lotteries-client.service';
import { IFramePostMessages } from '../../../../../models/modules/lotteryplatform-client.models';
import { Lottery } from '../lottery/lottery';
import { Syndicate } from '../syndicate/syndicate';
import { SyndicateKeyHelper } from '../../../../../services/modules/brand-client.service';
import { Results } from '../results/results';
import { Purchases } from '../purchases/purchases';
import { Cart } from '../cart/cart';
import { About } from '../about/about';
import { HowToPlay } from '../how-to-play/how-to-play';
import { HowToWin } from '../how-to-win/how-to-win';
import { PrizeMatrix } from '../prize-matrix/prize-matrix';
import { RouterConstants } from '../../../../../configuration/router.constants';
var Lobby = /** @class */ (function (_super) {
    __extends(Lobby, _super);
    function Lobby(router, lotteryClientService, lookupClientService, i18N, tokenClient, hotLotteryClientService, notificationClientService, dialogClientService, container) {
        var _this = _super.call(this, router, lotteryClientService, lookupClientService, i18N, hotLotteryClientService, tokenClient, notificationClientService, dialogClientService) || this;
        _this.container = container;
        _this.currentTab = {};
        return _this;
    }
    Lobby.prototype.resultsLoaded = function () {
        var route = JSON.parse(localStorage.getItem("".concat(IFramePostMessages.reloadPage, "-previous-route")));
        if (route.routeName == RouterConstants.RouteNames.Purchases && route.params && route.params.lotteryId) {
            this.navigateToPurchasesAndOpen(route.params.lotteryId);
            localStorage.removeItem("".concat(IFramePostMessages.reloadPage, "-previous-route"));
        }
    };
    Lobby.prototype.navigateToPurchasesAndOpen = function (lotteryId) {
        var tabs = this.tabs(lotteryId);
        this.currentTab[lotteryId] = tabs.filter(function (x) { return x.step == 7; })[0];
        this.openDraw(this.lotteryResults.filter(function (x) { return x.lotteryId == lotteryId; })[0]);
    };
    Lobby.prototype.tabs = function (lotteryId) {
        var _this = this;
        var self = this;
        var key = this.getLotteryKey(this.getLotteryById(lotteryId).lotteryName);
        var name = this.i18n.tr(key + '-lottery-name');
        var syndicate = this.container.get(Syndicate);
        var lottery = this.container.get(Lottery);
        var results = this.container.get(Results);
        var purchases = this.container.get(Purchases);
        var cart = this.container.get(Cart);
        var about = this.container.get(About);
        var howToPlay = this.container.get(HowToPlay);
        var howToWin = this.container.get(HowToWin);
        var prizeMatrix = this.container.get(PrizeMatrix);
        var syndicateNavigation = (function (syndicate, brandLotteryId) {
            var lotteryId = _this.lotteries.filter(function (x) { return x.brandLotteryId == brandLotteryId; }).map(function (x) { return x.lotteryId; })[0];
            var tab = _this.tabs(lotteryId).filter(function (x) { return x.title == "Syndicate"; })[0];
            tab.getModel = function (x) {
                return {
                    key: SyndicateKeyHelper.getKey(syndicate.name),
                    syndicateId: syndicate.syndicateId,
                    brandLotteryId: brandLotteryId
                };
            };
            _this.currentTab[lotteryId] = tab;
            _this.sendHeightToClient(_this.lastKnownHeight + "px", false);
        }).bind(this);
        var lotteryNavigation = (function (lottery) {
            var tabs = _this.tabs(lottery.lotteryId);
            _this.currentTab[lottery.lotteryId] = tabs[0];
            _this.sendHeightToClient(_this.lastKnownHeight + "px", false);
        }).bind(this);
        var cartNavigation = (function (lottery) {
            var tabs = _this.tabs(lottery.lotteryId);
            var tab = tabs.filter(function (x) { return x.title == "Cart"; })[0];
            _this.currentTab[lottery.lotteryId] = tab;
            _this.sendHeightToClient(_this.lastKnownHeight + "px", false);
        }).bind(this);
        lottery.navigateToSyndicateInternal = syndicateNavigation;
        syndicate.navigateToSyndicateInternal = syndicateNavigation;
        syndicate.navigateToLotteryInternal = lotteryNavigation;
        lottery.navigateToCartInternal = cartNavigation;
        syndicate.navigateToCartInternal = cartNavigation;
        return [{
                show: true,
                view: "../lottery/lottery.html",
                vm: lottery,
                title: "Play " + name,
                step: 1,
                getModel: function (x) {
                    return {
                        lotteryId: x.lotteryId,
                        key: self.getLotteryKey(self.getLotteryById(x.lotteryId).lotteryName),
                        brandLotteryId: x.brandLotteryId
                    };
                }
            }, {
                show: true,
                title: "About " + name,
                view: "../about/about.html",
                vm: about,
                step: 2,
                getModel: function (x) {
                    return {
                        key: self.getLotteryKey(self.getLotteryById(x.lotteryId).lotteryName),
                        lotteryId: x.lotteryId
                    };
                }
            }, {
                show: true,
                view: "../results/results.html",
                vm: results,
                title: "Past Results",
                step: 3,
                getModel: function (x) {
                    return {
                        key: self.getLotteryKey(self.getLotteryById(x.lotteryId).lotteryName),
                        lotteryId: x.lotteryId
                    };
                }
            }, {
                show: true,
                view: "../prize-matrix/prize-matrix.html",
                vm: prizeMatrix,
                title: "Prize Matrix",
                step: 4,
                getModel: function (x) {
                    return {
                        key: self.getLotteryKey(self.getLotteryById(x.lotteryId).lotteryName),
                        lotteryId: x.lotteryId,
                        brandLotteryId: self.getLotteryById(x.lotteryId).brandLotteryId
                    };
                }
            }, {
                show: true,
                title: "How to Play",
                view: "../how-to-play/how-to-play.html",
                vm: howToPlay,
                step: 5,
                getModel: function (x) {
                    return {
                        key: self.getLotteryKey(self.getLotteryById(x.lotteryId).lotteryName),
                        lotteryId: x.lotteryId
                    };
                }
            }, {
                show: true,
                view: "../how-to-win/how-to-win.html",
                vm: howToWin,
                title: "How to WIN",
                step: 6,
                getModel: function (x) {
                    return {
                        key: self.getLotteryKey(self.getLotteryById(x.lotteryId).lotteryName),
                        lotteryId: x.lotteryId
                    };
                }
            }, {
                show: this.tokenClient.isAuthenticated,
                view: "../purchases/purchases.html",
                vm: purchases,
                title: "My Purchases",
                step: 7,
                getModel: function (x) {
                    return {
                        key: self.getLotteryKey(self.getLotteryById(x.lotteryId).lotteryName),
                        lotteryId: x.lotteryId
                    };
                }
            }, {
                show: true,
                title: "Cart",
                view: "../cart/cart.html",
                vm: cart,
                getModel: function (x) {
                    return {
                        key: self.getLotteryKey(self.getLotteryById(x.lotteryId).lotteryName),
                        lotteryId: x.lotteryId,
                    };
                },
                step: 8
            }, {
                show: false,
                view: "../syndicate/syndicate.html",
                vm: syndicate,
                title: "Syndicate",
                step: 8
            }];
    };
    Lobby.prototype.navigateToLotteryAndOpen = function (lottery) {
        var tabs = this.tabs(lottery.lotteryId);
        this.currentTab[lottery.lotteryId] = tabs[0];
        this.openDraw(lottery);
    };
    Lobby.prototype.showResults = function () {
        window.parent.postMessage({
            key: BrandingBase.SelectBrandingKey,
            value: [
                //Text
                "lotteries-result-title",
                "lotteries-result-lotteries-combobox-label",
                "lotteries-result-date-combobox-label",
                "lotteries-result-more-prize-breakdown-title",
                "lotteries-result-more-prize-breakdown-table-prize-level",
                "lotteries-result-more-prize-breakdown-table-match",
                "lotteries-result-more-prize-breakdown-table-value",
                "lotteries-result-more-overview-title",
                "lotteries-result-more-draw-details-title",
                "lotteries-result-more-draw-details-table-schedule",
                "lotteries-result-more-draw-details-table-select",
                "lotteries-result-more-draw-details-table-jackpot",
                "lotteries-result-more-draw-details-table-tax",
                "lotteries-result-more-draw-details-weekly",
                "lotteries-result-more-draw-details-no-tax",
                "lotteries-result-bottom-text",
                "most-recent-label",
                "no-winner",
                //Images
                "template-background-xs",
                "template-background-sm",
                "template-background-lg",
                //Colors
                "template-background",
                "lotteries-lottery-background",
                "lotteries-lottery-border",
                "lotteries-lottery-name-foreground",
                "lotteries-lottery-country-foreground",
                "lotteries-lottery-number-border",
                "lotteries-lottery-number-background",
                "lotteries-lottery-number-foreground",
                "lotteries-lottery-bonus-number-background",
                "lotteries-lottery-bonus-number-foreground",
                "lotteries-lottery-prize-foreground",
                "lotteries-lottery-button-foreground",
                "lotteries-lottery-button-hover-foreground",
                "lotteries-lottery-button-background",
                "lotteries-lottery-button-hover-background",
                "lotteries-lottery-next-draw-foreground",
                "lotteries-lottery-result-details-expand-icon-color",
                "lotteries-lottery-result-details-background",
                "lotteries-lottery-result-details-border",
                "lotteries-lottery-result-details-foreground",
                "lotteries-lottery-expand-icon",
                "bottom-description",
                // "terms-and-conditions-foreground"
            ]
        }, window.parent.location.origin);
    };
    Lobby.prototype.showHottestLotteries = function () {
        window.parent.postMessage({
            key: BrandingBase.SelectBrandingKey,
            value: [
                //Text
                "hottest-lotteries-title",
                "hottest-lotteries-remaning-time",
                "hottest-lotteries-remaning-days",
                "hottest-lotteries-remaning-hours",
                "hottest-lotteries-remaning-minutes",
                "hottest-lotteries-button",
                //Colors
                "hottest-lotteries-title-foreground",
                "hottest-lotteries-background",
                "hottest-lotteries-details-foreground",
                "hottest-lotteries-details-digits-background",
                "hottest-lotteries-details-digits-foreground",
                "hottest-lotteries-prize-currency-foreground",
                "hottest-lotteries-prize-amount-foreground",
                "hottest-lotteries-prize-button-background",
                "hottest-lotteries-prize-button-foreground"
            ]
        }, window.parent.location.origin);
    };
    Lobby = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [Router, ClientLotteryClientService, LookupClientService, I18N, TokenClient,
            ClientHotLotteriesClientService, NotificationClientService, DialogClientService,
            Container])
    ], Lobby);
    return Lobby;
}(BaseResults));
export { Lobby };
